// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Lozenge_lozenge-container__zbMvC {
  width: fit-content;
  position: relative;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.Lozenge_lozenge-container--bold__I7azl {
  font-weight: bold;
}
.Lozenge_lozenge-container--upper__bdmx4 {
  text-transform: uppercase;
}
.Lozenge_lozenge-container--default__OIkGN {
  background-color: var(--m-neutral);
  color: var(--m-white);
}
.Lozenge_lozenge-container--default-subtle__KGYXN {
  background-color: var(--m-background-subtle-neutral);
  color: var(--m-neutral);
}
.Lozenge_lozenge-container--info__wyjym {
  background-color: var(--m-primary);
  color: var(--m-white);
}
.Lozenge_lozenge-container--info-subtle__B2gIF {
  background-color: var(--m-background-subtle-primary);
  color: var(--m-primary);
}
.Lozenge_lozenge-container--success__QPybk {
  background-color: var(--m-success);
  color: var(--m-white);
}
.Lozenge_lozenge-container--success-subtle__hQrNv {
  background-color: var(--m-background-subtle-success);
  color: var(--m-success);
}
.Lozenge_lozenge-container--warning__D1Zih {
  background-color: var(--m-warning);
  color: var(--m-text);
}
.Lozenge_lozenge-container--warning-subtle__66X6V {
  background-color: var(--m-background-subtle-warning);
  color: var(--m-warning-xbolder);
}
.Lozenge_lozenge-container--danger__83zSj {
  background-color: var(--m-danger);
  color: var(--m-white);
}
.Lozenge_lozenge-container--danger-subtle__LkP0- {
  background-color: var(--m-background-subtle-danger);
  color: var(--m-danger);
}
.Lozenge_lozenge-container--primary-subtle__9U6Nq {
  background-color: var(--m-background-subtle-primary);
  color: var(--m-primary);
}
.Lozenge_lozenge-container--warning-subtle__66X6V {
  background-color: var(--m-background-subtle-warning);
  color: var(--m-warning-xbolder);
}
.Lozenge_lozenge-container--danger-subtle__LkP0- {
  background-color: var(--m-background-subtle-danger);
  color: var(--m-danger);
}
.Lozenge_lozenge-container--neutral-subtle__gAqq7 {
  background-color: var(--m-background-subtle-neutral);
  color: var(--m-neutral);
}

[m-data-theme=dark] .Lozenge_lozenge-container--warning__D1Zih, [m-data-theme=dark] .Lozenge_lozenge-container--danger__83zSj, [m-data-theme=dark] .Lozenge_lozenge-container--success__QPybk, [m-data-theme=dark] .Lozenge_lozenge-container--default__OIkGN {
  color: #162949;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Lozenge/Lozenge.module.scss"],"names":[],"mappings":"AAAA;EAGE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,yBAAA;AAAJ;AAGE;EACE,kCAAA;EACA,qBAAA;AADJ;AAIE;EACE,oDAAA;EACA,uBAAA;AAFJ;AAKE;EACE,kCAAA;EACA,qBAAA;AAHJ;AAME;EACE,oDAAA;EACA,uBAAA;AAJJ;AAOE;EACE,kCAAA;EACA,qBAAA;AALJ;AAQE;EACE,oDAAA;EACA,uBAAA;AANJ;AASE;EACE,kCAAA;EACA,oBAAA;AAPJ;AAUE;EACE,oDAAA;EACA,+BAAA;AARJ;AAWE;EACE,iCAAA;EACA,qBAAA;AATJ;AAYE;EACE,mDAAA;EACA,sBAAA;AAVJ;AAYE;EACE,oDAAA;EACA,uBAAA;AAVJ;AAYE;EACE,oDAAA;EACA,+BAAA;AAVJ;AAYE;EACE,mDAAA;EACA,sBAAA;AAVJ;AAYE;EACE,oDAAA;EACA,uBAAA;AAVJ;;AAgBI;EAIE,cAAA;AAhBN","sourcesContent":[".lozenge-container {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  position: relative;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n\n  &--bold {\n    font-weight: bold;\n  }\n\n  &--upper {\n    text-transform: uppercase;\n  }\n\n  &--default {\n    background-color: var(--m-neutral);\n    color: var(--m-white);\n  }\n\n  &--default-subtle {\n    background-color: var(--m-background-subtle-neutral);\n    color: var(--m-neutral);\n  }\n\n  &--info {\n    background-color: var(--m-primary);\n    color: var(--m-white);\n  }\n\n  &--info-subtle {\n    background-color: var(--m-background-subtle-primary);\n    color: var(--m-primary);\n  }\n\n  &--success {\n    background-color: var(--m-success);\n    color: var(--m-white);\n  }\n\n  &--success-subtle {\n    background-color: var(--m-background-subtle-success);\n    color: var(--m-success);\n  }\n\n  &--warning {\n    background-color: var(--m-warning);\n    color: var(--m-text);\n  }\n\n  &--warning-subtle {\n    background-color: var(--m-background-subtle-warning);\n    color: var(--m-warning-xbolder);\n  }\n\n  &--danger {\n    background-color: var(--m-danger);\n    color: var(--m-white);\n  }\n\n  &--danger-subtle {\n    background-color: var(--m-background-subtle-danger);\n    color: var(--m-danger);\n  }\n  &--primary-subtle {\n    background-color: var(--m-background-subtle-primary);\n    color: var(--m-primary);\n  }\n  &--warning-subtle {\n    background-color: var(--m-background-subtle-warning);\n    color: var(--m-warning-xbolder);\n  }\n  &--danger-subtle {\n    background-color: var(--m-background-subtle-danger);\n    color: var(--m-danger);\n  }\n  &--neutral-subtle {\n    background-color: var(--m-background-subtle-neutral);\n    color: var(--m-neutral);\n  }\n}\n\n[m-data-theme=\"dark\"] {\n  .lozenge-container {\n    &--warning,\n    &--danger,\n    &--success,\n    &--default {\n      color: #162949;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lozenge-container": `Lozenge_lozenge-container__zbMvC`,
	"lozenge-container--bold": `Lozenge_lozenge-container--bold__I7azl`,
	"lozenge-container--upper": `Lozenge_lozenge-container--upper__bdmx4`,
	"lozenge-container--default": `Lozenge_lozenge-container--default__OIkGN`,
	"lozenge-container--default-subtle": `Lozenge_lozenge-container--default-subtle__KGYXN`,
	"lozenge-container--info": `Lozenge_lozenge-container--info__wyjym`,
	"lozenge-container--info-subtle": `Lozenge_lozenge-container--info-subtle__B2gIF`,
	"lozenge-container--success": `Lozenge_lozenge-container--success__QPybk`,
	"lozenge-container--success-subtle": `Lozenge_lozenge-container--success-subtle__hQrNv`,
	"lozenge-container--warning": `Lozenge_lozenge-container--warning__D1Zih`,
	"lozenge-container--warning-subtle": `Lozenge_lozenge-container--warning-subtle__66X6V`,
	"lozenge-container--danger": `Lozenge_lozenge-container--danger__83zSj`,
	"lozenge-container--danger-subtle": `Lozenge_lozenge-container--danger-subtle__LkP0-`,
	"lozenge-container--primary-subtle": `Lozenge_lozenge-container--primary-subtle__9U6Nq`,
	"lozenge-container--neutral-subtle": `Lozenge_lozenge-container--neutral-subtle__gAqq7`
};
export default ___CSS_LOADER_EXPORT___;
